import classnames from 'classnames'
import PropTypes from 'prop-types'

import './ProgressDot.scss'

const ProgressDot = ({ complete }) => {
  const classNames = classnames('c-progress-dot', {
    'c-progress-dot--complete': complete,
  })
  return <div className={classNames} />
}

ProgressDot.propTypes = {
  complete: PropTypes.bool,
}

export { ProgressDot }
export default ProgressDot
